import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import parse from "html-react-parser";
import QualificationJourney from "./QualificationJourney";
import ExperienceJourney from "./ExperienceJourney";
import CertificationsPreview from "./CertificationsPreview";

const RightSideContent = ({ additional_fields, details }) => {
  console.log("details@@", details);

  return (
    <React.Fragment>
      <Col lg={8}>
   <Card className="profile-content-page border-0 shadow-sm mt-4 mt-lg-0 overflow-hidden">
  <CardBody className="p-4 p-md-5">
    {/* 📋 SECTION 1: BASIC INFO */}
    <div className="mb-5">
      <div className="d-flex align-items-center justify-content-between mb-1">
        <div className="d-flex align-items-center">
          <div
            className="icon-badge bg-soft-primary text-primary me-3 d-flex align-items-center justify-content-center rounded-3"
            style={{ width: "40px", height: "40px" }}
          >
            <i className="uil uil-user fs-20"></i>
          </div>
          <h5 className="fs-18 fw-bold mb-0 text-dark">Basic Information</h5>
        </div>
        {/* 🟢 Employer Hook */}
        <span className="badge bg-soft-success text-success px-3 py-2 fs-13 fw-semibold rounded-pill">
          <i className="uil uil-user-check me-1"></i> Basic Candidate Details Available
        </span>
      </div>
      <p className="text-muted fs-13 mb-3 ps-5 ms-1">
        Explore this candidate's career highlights and core strengths at zero credit cost.
      </p>

      {/* 📊 QUICK HIGHLIGHT CARDS (Location, Experience, Salary) */}
      <div className="row g-3 ms-5 me-0 mb-3">
        {/* Location Card */}
        <div className="col-12 col-md-4">
          <div className="bg-light p-3 rounded-3 border border-light d-flex align-items-center h-100">
            <div
              className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-3 shadow-sm flex-shrink-0"
              style={{ width: "38px", height: "38px" }}
            >
              <i className="uil uil-location-point fs-18"></i>
            </div>
            <div>
              <span className="text-muted fs-12 d-block fw-medium">Location</span>
              <span className="fw-semibold text-dark fs-14">
                {[details?.data?.city || details?.data?.location, details?.data?.state]
                  .filter(Boolean)
                  .join(", ") || "Not Mention"}
              </span>
            </div>
          </div>
        </div>

        {/* Total Experience Card */}
        <div className="col-12 col-md-4">
          <div className="bg-light p-3 rounded-3 border border-light d-flex align-items-center h-100">
            <div
              className="bg-white text-info rounded-circle d-flex align-items-center justify-content-center me-3 shadow-sm flex-shrink-0"
              style={{ width: "38px", height: "38px" }}
            >
              <i className="uil uil-briefcase-alt fs-18"></i>
            </div>
            <div>
              <span className="text-muted fs-12 d-block fw-medium">Experience</span>
              <span className="fw-semibold text-dark fs-14">
                {details?.data?.totalWorkExperience || "Not Mention"}
              </span>
            </div>
          </div>
        </div>

        {/* Current Salary Card */}
        <div className="col-12 col-md-4">
          <div className="bg-light p-3 rounded-3 border border-light d-flex align-items-center h-100">
            <div
              className="bg-white text-success rounded-circle d-flex align-items-center justify-content-center me-3 shadow-sm flex-shrink-0"
              style={{ width: "38px", height: "38px" }}
            >
              <i className="uil uil-bill fs-18"></i>
            </div>
            <div>
              <span className="text-muted fs-12 d-block fw-medium">Current Salary</span>
              <span className="fw-semibold text-dark fs-14">
                {details?.data?.currentSalary
                  ? `₹${Number(details.data.currentSalary).toLocaleString("en-IN")}`
                  : "Not Mention"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Details Summary */}
      <div className="text-secondary bg-light p-4 rounded-3 border border-light fs-15 lh-base ms-5">
        {details?.data?.details ? (
          parse(details.data.details)
        ) : (
          <span className="text-muted fst-italic fs-14">
            No profile summary details available.
          </span>
        )}
      </div>
    </div>

    {/* CORE SKILLS SECTION */}
    <div className="mb-5">
      <div className="d-flex align-items-center justify-content-between mb-1">
        <div className="d-flex align-items-center">
          <div
            className="icon-badge bg-soft-primary text-primary me-3 d-flex align-items-center justify-content-center rounded-3"
            style={{ width: "40px", height: "40px" }}
          >
            <i className="uil uil-wrench fs-20"></i>
          </div>
          <h5 className="fs-18 fw-bold mb-0 text-dark">Core Skills</h5>
        </div>
        <span className="badge bg-soft-primary text-primary px-3 py-2 fs-13 fw-semibold rounded-pill">
          <i className="uil uil-star me-1"></i> Verified Talents
        </span>
      </div>
      <p className="text-muted fs-13 mb-3 ps-5 ms-1">
        Review the candidate's core industry knowledge and technical expertise.
      </p>

      <div className="bg-light p-4 rounded-3 border border-light ms-5">
        {details?.data?.skills ? (
          <div className="d-flex flex-wrap gap-2">
            {details.data.skills
              .split(",")
              .filter(Boolean)
              .map((skill, index) => (
                <span
                  key={index}
                  className="badge bg-white text-dark border px-3 py-2 fs-13 fw-medium shadow-sm rounded-2"
                >
                  {skill.trim()}
                </span>
              ))}
          </div>
        ) : (
          <span className="text-muted fst-italic fs-14">
            No technical skills added yet.
          </span>
        )}
      </div>
    </div>

    {/* LANGUAGES KNOWN SECTION */}
    <div className="mb-5">
      <div className="d-flex align-items-center justify-content-between mb-1">
        <div className="d-flex align-items-center">
          <div
            className="icon-badge bg-soft-primary text-primary me-3 d-flex align-items-center justify-content-center rounded-3"
            style={{ width: "40px", height: "40px" }}
          >
            <i className="uil uil-comments fs-20"></i>
          </div>
          <h5 className="fs-18 fw-bold mb-0 text-dark">Languages Known</h5>
        </div>
      </div>

      <p className="text-muted fs-13 mb-3 ps-5 ms-1">
        Communication capabilities for teamwork and workplace operations.
      </p>

      <div className="bg-light p-4 rounded-3 border border-light ms-5">
        {details?.data?.languagesKnown ? (
          <div className="d-flex flex-wrap gap-2">
            {details.data.languagesKnown
              .split(",")
              .filter(Boolean)
              .map((lang, index) => (
                <span
                  key={index}
                  className="badge bg-soft-success text-success border border-success-subtle px-3 py-2 fs-13 fw-medium rounded-2"
                >
                  <i className="uil uil-globe me-1"></i> {lang.trim()}
                </span>
              ))}
          </div>
        ) : (
          <span className="text-muted fst-italic fs-14">
            No languages listed.
          </span>
        )}
      </div>
    </div>

    <hr className="my-4 border-dashed opacity-25" />

    {/* 🎓 SECTION 2: QUALIFICATIONS */}
    <div className="candidate-education-details mb-5">
      <div className="d-flex align-items-center mb-1">
        <div
          className="icon-badge bg-soft-primary text-success me-3 d-flex align-items-center justify-content-center rounded-3"
          style={{ width: "40px", height: "40px" }}
        >
          <i className="uil uil-book-open fs-20"></i>
        </div>
        <h6 className="fs-18 fw-bold mb-0 text-dark">Qualifications & Education</h6>
      </div>
      <p className="text-muted fs-13 mb-3 ps-5 ms-1">
        Verified academic history and professional training credentials.
      </p>

      <div className="ps-5 ms-1">
        <QualificationJourney initialData={details?.data?.qualifications} />
      </div>
    </div>

    <hr className="my-4 border-dashed opacity-25" />

    {/* 💼 SECTION 3: WORK EXPERIENCE */}
    <div className="candidate-education-details mb-5">
      <div className="d-flex align-items-center mb-1">
        <div
          className="icon-badge bg-soft-info text-info me-3 d-flex align-items-center justify-content-center rounded-3"
          style={{ width: "40px", height: "40px" }}
        >
          <i className="uil uil-briefcase-alt fs-20"></i>
        </div>
        <div>
          <h6 className="fs-18 fw-bold mb-0 text-dark">Total Work Experience</h6>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between ps-5 ms-1 mb-3">
        <p className="text-muted fs-13 mb-0">
          A complete timeline of past roles, achievements, and technical capabilities.
        </p>
        {details?.data?.totalWorkExperience && (
          <span className="badge bg-soft-info text-info px-2.5 py-1.5 fs-13 fw-semibold rounded">
            Track: {details.data.totalWorkExperience}
          </span>
        )}
      </div>

      <div className="ps-5 ms-1">
        <ExperienceJourney
          initialData={
            details?.data?.experiences || details?.data?.workExperiences || []
          }
          componentType="overview"
        />
      </div>
    </div>

    <hr className="my-4 border-dashed opacity-25" />
  </CardBody>
</Card>
      </Col>
    </React.Fragment>
  );
};

export default RightSideContent;
